export const getPreviousAuthUrl = (locationFrom: ILocationState['from']) => {
  const { pathname, search } = locationFrom;
  return pathname + search;
};
